import type {AxiosPromise} from 'axios'
import axios from '@/plugin/axios'
import api from '@/api'

export const auth = {
  fetchIdentity,
  fetchOrgDescendants
}

function fetchIdentity(): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.IDENTITY)
}

function fetchOrgDescendants(): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.ORG_DESCENDANTS)
}
